import * as yup from 'yup';

export const signupschema = yup.object().shape({
    username: yup.string().required('Username is required'),
    email: yup.string().email().required('Email is required'),
    password: yup.string().matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,'Password must be eight characters including one uppercase letter, one special character and alphanumeric characters( Ex: Ps#12354 )').required('Password is required'),
    termsandservice:yup.boolean().oneOf([true,null],'You must agree to our terms and services to signup')
});